/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Careers_Whatwedo_Products2Inputs */

const ja_careers_whatwedo_products2 = /** @type {(inputs: Careers_Whatwedo_Products2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ゲーム関連製品をECサイトで販売`)
};

const en_careers_whatwedo_products2 = /** @type {(inputs: Careers_Whatwedo_Products2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Game Products and EC Stores`)
};

/**
* | output |
* | --- |
* | "Game Products and EC Stores" |
*
* @param {Careers_Whatwedo_Products2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const careers_whatwedo_products2 = /** @type {((inputs?: Careers_Whatwedo_Products2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Careers_Whatwedo_Products2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_careers_whatwedo_products2(inputs)
	return en_careers_whatwedo_products2(inputs)
});
export { careers_whatwedo_products2 as "careers_whatWeDo_products" }